<app-page>
    <app-loadable-content [loadingController]="businessLoadingController" (onRetry)="loadBusiness()">
        <app-title>{{ pageTitle }}</app-title>
        <div>
            <table>
                <tr>
                    <td>
                        <app-action [text]="'expand_all' | translate" [defaultStyle]=true (onExecute)="accordion.openAll(); editLocationSettingsComponentAccordionOpenAll()"></app-action>
                    </td>
                    <td>
                        <app-action [text]="'collapse_all' | translate" [defaultStyle]=true (onExecute)="accordion.closeAll(); editLocationSettingsComponentAccordionCloseAll()"></app-action>
                    </td>
                    <td>
                        <app-action [text]="'go_to_business' | translate" [defaultStyle]=true (onExecute)="goToBusinessPage()"></app-action>
                    </td>
                </tr>
            </table>
        </div>
        <mat-accordion multi>
            <!-- ------------------------------------------------------------------ -->
            <!-- General config -->
            <!-- ------------------------------------------------------------------ -->
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ 'general' | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div appFieldContainer>
                    <mat-form-field appField>
                        <mat-label>{{ 'business_name' | translate }}</mat-label>
                        <input matInput [formControl]="generalConfigFields.name" required>
                        <mat-error *ngIf="generalConfigFields.name.invalid">{{formService.getFieldErrorMessage(generalConfigFields.name)}}</mat-error>
                    </mat-form-field>
                    <mat-form-field appField>
                        <mat-label>{{ 'description_en' | translate }}</mat-label>
                        <textarea matInput [formControl]="generalConfigFields.descriptionEn" required></textarea>
                        <mat-error *ngIf="generalConfigFields.descriptionEn.invalid">{{formService.getFieldErrorMessage(generalConfigFields.descriptionEn)}}</mat-error>
                    </mat-form-field>
                    <mat-form-field appField>
                        <mat-label>{{ 'description_es' | translate }}</mat-label>
                        <textarea matInput [formControl]="generalConfigFields.descriptionEs" required></textarea>
                        <mat-error *ngIf="generalConfigFields.descriptionEs.invalid">{{formService.getFieldErrorMessage(generalConfigFields.descriptionEs)}}</mat-error>
                    </mat-form-field>
                    <p>
                    Aliases that can be used with the vanity URL:
                    <ul>
                        <li>waiternow.{{domainExtension}}/order/{{getVanityUrlForUrlExample()}}</li>
                        <li>backend.waiternow.{{domainExtension}}/service/order/{{getVanityUrlForUrlExample()}}</li>
                        <li>placeorderat.{{domainExtension}}/{{getVanityUrlForUrlExample()}}</li>
                        <li>ordenaren.{{domainExtension}}/{{getVanityUrlForUrlExample()}}</li>
                    </ul>
                    <mat-form-field appField>
                        <mat-label>{{ 'vanity_url' | translate }}</mat-label>
                        <input matInput [formControl]="generalConfigFields.vanityUrl" placeholder="oldtemplebar">
                        <mat-error *ngIf="generalConfigFields.vanityUrl.invalid">{{formService.getFieldErrorMessage(generalConfigFields.vanityUrl)}}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <app-action [text]="'save' | translate"
                        [disabled]="generalConfigFields.name.invalid || generalConfigFields.descriptionEn.invalid || generalConfigFields.descriptionEs.invalid"
                        (onAsyncExecute)="saveGeneral($event)">
                    </app-action>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <!-- app-edit-location-settings also defines an accordion -->
        <app-edit-location-settings
            [businessId]="businessId"
            [locationSettings]="locationSettings"
            *ngIf="sessionService.getIsSuperuser()">
        </app-edit-location-settings>
    </app-loadable-content>
</app-page>
